export const getBulkPackagingKey = (unit: string, contextName: string = "") => {
  if (!unit) return "Box"; // Default fallback
  const lowerUnit = unit.toLowerCase();
  const lowerContext = contextName.toLowerCase();
  
  if (lowerUnit === "coil") return "Box";
  if (lowerUnit === "kg") {
      if (lowerContext.includes("copper brazing") || lowerContext.includes("brazing rod")) {
          return "Box";
      }
      return "Cylinder";
  }
  if (lowerUnit.includes("pcs") || lowerUnit === "piece" || lowerUnit === "pieces") return "Box";
  if (lowerUnit === "packet") return "Packet";
  if (lowerUnit === "liter" || lowerUnit === "ltr" || lowerUnit === "litre") return "Box";
  if (lowerUnit === "can") return "Box";
  
  // Default to Box if unknown unit
  return "Box";
};

export const isBulkPackagingKey = (key: string) => {
  const k = key?.trim().toLowerCase() || "";
  return (
    k === "rolls /box" ||
    k === "rolls/box" ||
    k === "rolls / box" ||
    k === "box" ||
    k === "cylinder" ||
    k === "packet" ||
    k === "bottle" ||
    k === "can" ||
    k === "drum" ||
    k === "carton"
  );
};
